module.exports = __webpack_public_path__ + "images/kihnu/routes/KIH-MUN-KIH-NEW.png";